// Validierung/Normalisierung für Schweizer Mitarbeiter-Stammdaten.
// Wird im Admin-Portal und im Onboarding-Formular genutzt, damit ungültige
// Werte gar nicht erst gespeichert werden können (gleiche Regeln wie im Backend).

// Wandelt diverse Eingaben in ISO (JJJJ-MM-TT). Leerer String = ungültig/leer.
export function dobToISO(v) {
  if (!v) return '';
  const s = String(v).trim();
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
    const dt = new Date(s + 'T00:00:00');
    return !isNaN(dt.getTime()) && dt.getMonth() + 1 === Number(s.slice(5, 7)) ? s : '';
  }
  const m = s.match(/^(\d{1,2})[./-](\d{1,2})[./-](\d{2,4})$/);
  if (!m) return '';
  let [, d, mo, y] = m;
  if (y.length === 2) y = (Number(y) > 30 ? '19' : '20') + y;
  const mm = mo.padStart(2, '0');
  const dd = d.padStart(2, '0');
  const iso = `${y}-${mm}-${dd}`;
  const dt = new Date(iso + 'T00:00:00');
  if (isNaN(dt.getTime()) || dt.getMonth() + 1 !== Number(mm) || dt.getDate() !== Number(dd)) return '';
  if (dt.getFullYear() < 1900 || dt.getFullYear() > new Date().getFullYear()) return '';
  return iso;
}

// Gibt Fehlermeldung zurück oder '' wenn gültig.
export function validateDob(v) {
  if (!v) return '';
  return dobToISO(v) ? '' : 'Ungültiges Geburtsdatum. Bitte ein echtes Datum im Format TT.MM.JJJJ eingeben (z. B. 07.05.1995).';
}

export function validateAhv(v) {
  if (!v) return '';
  const digits = String(v).replace(/\D/g, '');
  if (digits.length !== 13 || !digits.startsWith('756')) {
    return 'Ungültige AHV-Nummer. Format: 756.XXXX.XXXX.XX (13 Ziffern, beginnt mit 756).';
  }
  let sum = 0;
  for (let i = 0; i < 12; i++) sum += Number(digits[i]) * (i % 2 ? 3 : 1);
  if ((10 - (sum % 10)) % 10 !== Number(digits[12])) return 'Ungültige AHV-Nummer (Prüfziffer stimmt nicht).';
  return '';
}

export function formatAhv(v) {
  const d = String(v || '').replace(/\D/g, '');
  if (d.length !== 13) return v;
  return `${d.slice(0, 3)}.${d.slice(3, 7)}.${d.slice(7, 11)}.${d.slice(11, 13)}`;
}

export function validateIban(v) {
  if (!v) return '';
  const c = String(v).replace(/\s/g, '').toUpperCase();
  if (!/^[A-Z]{2}\d{2}[A-Z0-9]+$/.test(c)) return 'Ungültige IBAN.';
  if ((c.startsWith('CH') || c.startsWith('LI')) && c.length !== 21) {
    return 'Ungültige IBAN (Schweizer IBAN hat 21 Zeichen, z. B. CH93 0076 2011 6238 5295 7).';
  }
  const rearranged = c.slice(4) + c.slice(0, 4);
  let rem = 0;
  for (const ch of rearranged) {
    const val = parseInt(ch, 36);
    rem = val > 9 ? (rem * 100 + val) % 97 : (rem * 10 + val) % 97;
  }
  return rem === 1 ? '' : 'Ungültige IBAN (Prüfsumme stimmt nicht).';
}

// ---- Eingabe-Masken: formatieren während des Tippens, nur erlaubte Zeichen ----

export function maskDob(v) {
  const d = String(v || '').replace(/\D/g, '').slice(0, 8); // TTMMJJJJ
  const p = [d.slice(0, 2)];
  if (d.length > 2) p.push(d.slice(2, 4));
  if (d.length > 4) p.push(d.slice(4, 8));
  return p.join('.');
}

export function maskAhv(v) {
  const d = String(v || '').replace(/\D/g, '').slice(0, 13);
  const p = [d.slice(0, 3)];
  if (d.length > 3) p.push(d.slice(3, 7));
  if (d.length > 7) p.push(d.slice(7, 11));
  if (d.length > 11) p.push(d.slice(11, 13));
  return p.join('.');
}

export function maskIban(v) {
  const c = String(v || '').replace(/[^A-Za-z0-9]/g, '').toUpperCase().slice(0, 34);
  return c.replace(/(.{4})/g, '$1 ').trim();
}

